"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementContains = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "elementContains", { enumerable: true, get: function () { return dom_utilities_1.elementContains; } });
//# sourceMappingURL=elementContains.js.map